<template>
  <div v-if="$ml.list.length > 1">
    <img
      v-for="lang in $ml.list"
      :key="lang"
      :src="'/resources/flag_' + lang + '.svg'"
      class="flag"
      @click="
        () => {
          $ml.change(lang);
        }
      "
    />
  </div>
</template>

<script>
export default {
  name: "LangChooser",
  props: {},
  data() {
    return {};
  },
};
</script>

<style>
.flag {
  height: 1rem;
  cursor: pointer;
  padding-right: 5px;
}
</style>
